import {useAddressDetails} from "../../backend2/address/useAddress";
import {useCarrierDetails} from "../../backend2/admin/carrier/useCarrier";
import {Button} from "react-bootstrap";
import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../../../context";
import {OurClearAlert} from "../../_components";
import {getPriceWithVat, getVat} from "../../../utils2";

export function OrderSummary({basket, disabled, className}) {
    const location = useLocation()
    const navigate = useNavigate()
    const {user} = useAuth()

    const stepMap = {
        "/shop/cart": 0,
        "/checkout/address": 1,
        "/checkout/delivery": 2,
        "/checkout/payment": 3,
    }
    const currentStep = stepMap[location.pathname]

    const vatToShow = currentStep >= 2 ? basket?.vat_percentage : user?.vat_percentage

    return <>
        <div className={`d-flex flex-column my-2 bg-light-subtle rounded p-3 ${className}`}>
            <div className="fs-5 my-2 fw-medium">Summary</div>

            <Articles basket={basket} vat={vatToShow}/>

            {currentStep >= 2 &&
                <Address addressId={basket?.address_id}/>
            }

            {currentStep >= 3 &&
                <Carrier carrierId={basket?.carrier_id}/>
            }

            <div className="d-flex justify-content-center">
                {currentStep === 0 ? (
                    <Button variant="success" className="my-2" onClick={() => navigate("/checkout/address")} disabled={disabled}>Proceed to checkout</Button>
                ) : currentStep === 3 ? (
                    <Button variant="success" className="my-2" type="submit" disabled={disabled}>Review & Pay</Button>
                ) : (
                    <Button variant="success" className="my-2" type="submit" disabled={disabled}>Continue</Button>
                )}
            </div>
        </div>
    </>
}

function Articles({basket, vat}) {
    const count = basket?.articles?.length

    return <>
        <div className="d-flex align-items-center">
            <div>Article(s):</div>
            <div className="ms-auto text-nowrap">{count > 1 ? `${count} items` : "1 item"}</div>
        </div>

        <div className="d-flex align-items-top">
            <div className="me-2">Price excl. VAT:</div>
            <div className="ms-auto">
                {basket?.coupon_price !== 0 ?
                    <div className="">{basket?.bsk_price} €</div>
                    :
                    <div>
                        <div className="d-flex flex-wrap">
                            <div className="text-decoration-line-through text-nowrap">{basket?.bsk_price} €</div>
                            {/*<div className="text-danger ms-2">-{article.coupon_discount}%</div>*/}
                        </div>
                        <div className="text-danger ">{basket?.coupon_price} €</div>
                    </div>
                }
            </div>
        </div>
        {vat > 0 && <div className="d-flex align-items-center">
            <div>{vat}% VAT:</div>
            {/*<div className="ms-auto text-nowrap">{getPriceWithVat(basket?.bsk_price, vat)} €</div>*/}
            <div className="ms-auto text-nowrap">{getVat(basket?.bsk_price, vat)} €</div>
        </div>}
    </>
}

function Address({addressId}) {
    const {userId} = useAuth()

    const {
        value,
        loadingValue,
        errorValue,
        clearError
    } = useAddressDetails(addressId, userId, null)

    const shortName =  value?.name
        ?.split(" ")
        .filter(word => word) // removes empty strings
        .map(word => word[0]?.toUpperCase() + ".")
        .join(" ")

    return <>
        <OurClearAlert variant="danger" msg={errorValue} onClear={clearError}/>

        <div className="d-flex align-items-top">
            <div className="me-2 text-nowrap d-none d-lg-block">Ship To:</div>
            <div className="me-2 text-nowrap d-lg-none">To:</div>
            <div className="fw-semibold ms-auto">
                <div className="d-flex flex-column text-end">
                    {addressId == null || loadingValue ?
                        <div>Loading...</div>
                        : value ?
                            <>
                            <div className="d-none d-lg-block">{`${value.name}, ${value.city}`}</div>
                            <div className="d-lg-none">{`${shortName}, ${value.city}`}</div>
                            </>
                            :
                            <div>No address selected</div>
                    }
                </div>
            </div>
        </div>
    </>
}

function Carrier({carrierId}) {
    const {userId, user} = useAuth()

    const {
        value,
        loadingValue,
        errorValue,
        clearError
    } = useCarrierDetails(carrierId, userId)


    return <>
        <OurClearAlert variant="danger" msg={errorValue} onClear={clearError}/>

        <div className="d-flex align-items-top">
            <div className="me-2 text-nowrap">Ship costs:</div>
            <div className="fw-semibold ms-auto">
                <div className="d-flex flex-column text-end">
                    {carrierId == null || loadingValue ?
                        <div>Loading...</div>
                        : value ?
                            <div>{`${value.company}, ${getPriceWithVat(value.price, user?.vat_percentage)} €`}</div>
                            :
                            <div>No delivery method selected</div>
                    }
                </div>
            </div>
        </div>
    </>
}